export default __webpack_public_path__ + "static/media/catlikeexterior0000.40893d84.png";